import { PUBLISH_PLATFORM, PUBLISH_STATUS } from '~/api/interface/publish';

// 小红书授权key、secret
export const XHS_APP_KEY = 'red.ov7iU6CdD0LERyQH';
export const XHS_APP_SECRET = '46195ff4a1b791e5b1842ab46fca1e55';

export const PLATFORM_TYPE: () => Record<
  PUBLISH_PLATFORM,
  { name: string; icon?: string }
> = () => {
  const { $t } = useNuxtApp();
  return {
    [PUBLISH_PLATFORM.DOUYIN]: {
      name: $t('dou-yin'),
      icon: getFeUrl('/youyan-platform/png/platform-tiktok.png'),
    },
    [PUBLISH_PLATFORM.KUAISHOU]: {
      name: $t('kuai-shou'),
      icon: getFeUrl('/youyan-platform/png/platform-ks.png'),
    },
    [PUBLISH_PLATFORM.BLIBLI]: {
      name: $t('b-zhan'),
      icon: getFeUrl('/youyan-platform/png/platform-blibli.png'),
    },
    [PUBLISH_PLATFORM.XHS]: {
      name: $t('xiao-hong-shu'),
      // icon: BliBli
    },
    [PUBLISH_PLATFORM.TIKTOK]: {
      name: 'tiktok',
      icon: getFeUrl('/youyan-platform/png/tiktok.png'),
    },
    [PUBLISH_PLATFORM.YOUTUBE]: {
      name: 'youtube',
      icon: getFeUrl('/youyan-platform/png/youbube.png'),
    },
    [PUBLISH_PLATFORM.EMAIL]: {
      name: 'email',
      icon: getFeUrl('/youyan-platform/png/email.png'),
    },
  };
};

export const UPLOAD_STATUS_MAP = () => {
  const { $t } = useNuxtApp();
  return {
    [PUBLISH_STATUS.WAIT]: $t('dai-fa-bu'),
    [PUBLISH_STATUS.DOING]: $t('fa-bu-zhong'),
    [PUBLISH_STATUS.FINISH]: $t('fa-bu-wan-cheng'),
    [PUBLISH_STATUS.CANCEL]: $t('fa-bu-qu-xiao'),
    [PUBLISH_STATUS.FAIL]: $t('fa-bu-shi-bai'),
  };
};
